import { usePage } from "@inertiajs/react";
import Layout from "@/layouts/layout";
import Panel from "@/components/ui/Panel";
import SpeechHeading from "@/components/ui/SpeechHeading";
import { ButtonLink } from "@/components/ui/Button";
import type { PublicProps } from "@/types";

// Stands in for every guide page while HQ is still writing them. Reachable
// logged out, because the organizer handbook is linked from places someone
// hits before they have an account.
export default function GuidesLocked({ message }: { message: string }) {
  const { props } = usePage<PublicProps>();
  const program = props.program;

  return (
    <Layout>
      <div className="flex flex-col gap-8">
        <SpeechHeading
          title="Guides are on the way"
          subtitle="Not quite ready to be read yet."
        />

        <Panel title="coming-soon.txt" className="max-w-2xl">
          <div className="flex flex-col gap-4">
            <p className="text-body text-ink">{message}</p>

            <p className="text-caption text-ink-muted">
              You don't need any of them to apply. Everything the application
              asks for is a rough answer about your city and how many people
              you're picturing, and we'll walk you through the rest once you're
              picked.
            </p>

            <div className="flex flex-wrap gap-3">
              {program.organizer_applications_open && (
                <ButtonLink href="/organize/new">Apply to organize</ButtonLink>
              )}
              {program.events_enabled && (
                <ButtonLink href="/events" variant="secondary">
                  Browse events
                </ButtonLink>
              )}
            </div>

            {program.support_channel_url && (
              <p className="text-caption text-ink-soft">
                Questions in the meantime?{" "}
                <a
                  className="text-link font-bold underline"
                  href={program.support_channel_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {program.support_channel_name ?? "Ask us"}
                </a>
                .
              </p>
            )}
          </div>
        </Panel>
      </div>
    </Layout>
  );
}
